
export class PaginationHelpers {

  static getPostOptions(filters = {}, page: number = 1, items: number = 20, total = false) {
    const options = {
      pagination: {
        page,
        items,
        order: 'created_at',
        sort: 'desc',
        total: null
      },
      filters
    };

    if (total) { options.pagination.total = total; }
    return options;
  }

  static getGetOptions(page: number = 1, items: number = 20, total = false) {
    const options = {
      page: page.toString(),
      items: items.toString(),
      order: 'created_at',
      sort: 'desc',
      total: null
    };

    if (total) { options.total = 'true'; }

    return options;
  }
}
